/* eslint-disable flowtype/require-valid-file-annotation */
import * as R from "ramda"
import { Set } from "immutable"
import { set } from "splitster-redux"

import { get } from "common/utils/get"
import cuckoo from "common/services/cuckoo/cuckoo"
import { TAB_TYPES } from "common/consts/account"
import { MODALS } from "mmb/consts/booking"
import { postMessageToPayment } from "booking/scenes/ReservationForm/scenes/Payment/components/PaymentIframe"

export const testUsers = [
  // Test account first
  { email: "test@kiwi.com", password: "" },
  // Rest sorted alphabetically
  { email: "adam.allshare@kiwi.com", password: "" },
  { email: "alzbeta.palowska@skypicker.com", password: "" },
  { email: "barbora@kiwi.com", password: "" },
  { email: "domi@kiwi.com", password: "" },
  { email: "ellie@kiwi.com", password: "" },
  { email: "hanka@kiwi.com", password: "" },
  { email: "honza.soukop@kiwi.com", password: "" },
  { email: "internal_partner@kiwi.com", password: "" },
  { email: "karolina@kiwi.com", password: "" },
  { email: "mayyas.hazeemeh@kiwi.com", password: "" },
  { email: "meme.maister@kiwi.com", password: "" },
  { email: "newklarka@kiwi.com", password: "" },
  { email: "rozok@kiwi.com", password: "" },
  { email: "strajk@me.com", password: "" },
  { email: "tony@kiwi.com", password: "" },
  { email: "translator@kiwi.com", password: "" },
  { email: "vasekvasek@kiwi.com", password: "" },
  { email: "veru@kiwi.com", password: "" },
  { email: "germi@kiwi.com", password: "" },
  { email: "tapi@kiwi.com", password: "" },
]

function fillForm(def) {
  R.forEachObjIndexed((val, sel) => {
    const el = document.querySelector(sel)
    el.value = val
    el.dispatchEvent(new Event("input", { bubbles: true }))
  }, def)
}

export function smartFill(preparedUser) {
  cuckoo.disable()
  const state = window.reduxStore.getState()

  // Detect what form to fill
  const OPTIONS = {
    RESERVATION: "RESERVATION",
    LOGIN_PASSWORD: "LOGIN_PASSWORD",
    LOGIN_BOOKING: "LOGIN_BOOKING",
    SIGNUP: "SIGNUP",
    BOOKING_PAYMENT: "BOOKING_PAYMENT",
  }

  let option

  if (state.modals.hasIn(["login", "activeTab"])) {
    const activeTab = state.modals.getIn(["login", "activeTab"])
    switch (activeTab) {
      case TAB_TYPES.SIGN_IN:
        option = OPTIONS.LOGIN_PASSWORD
        break
      case TAB_TYPES.ONE_BOOKING:
        option = OPTIONS.LOGIN_BOOKING
        break
      case TAB_TYPES.SIGN_UP:
        option = OPTIONS.SIGNUP
        break
    }
  } else {
    if (state.booking && state.booking.modal === MODALS.PAYMENT) {
      option = OPTIONS.BOOKING_PAYMENT
    }

    const page = state.page.get("name")
    switch (page) {
      case "search":
        break
      case "booking":
        option = OPTIONS.RESERVATION
        break
    }
  }

  let user = preparedUser
  const mapIndexed = R.addIndex(R.map)

  if (!user) {
    const usersString = R.compose(
      R.join("\n"),
      mapIndexed((x, i) => `${i}: ${x.email}`),
    )(testUsers)
    const userIndex = window.prompt(usersString, 0)
    user = testUsers[userIndex] || testUsers[0] // safe default
  }

  // Constants for different age groups
  const currentYear = new Date().getFullYear()
  const adultThreshold = 18
  const childThreshold = 2
  const adultYear = currentYear - adultThreshold - 1 // Above adult threshold
  const childYear = currentYear - childThreshold - 1 // Above child threshold
  const infantYear = currentYear - childThreshold + 1 // Below child threshold

  // passengers[] means, it will be filled for all passengers
  // passengers[INDEX] means it will only be used for INDEX passenger
  // If no passenger is found for INDEX, the value won't be used
  // Specific values (with INDEX) override global values
  const FIELDS = {
    "passengers[].title": "mr",
    "passengers[].firstname": "TEST",
    "passengers[].lastname": "TEST",
    "passengers[1].firstname": "Test Second",
    "passengers[1].lastname": "Test Second",
    "passengers[2].firstname": "Test Third",
    "passengers[2].lastname": "Test Third",
    "passengers[3].firstname": "Test Forth",
    "passengers[3].lastname": "Test Forth",
    "passengers[4].firstname": "Test Fifth",
    "passengers[4].lastname": "Test Fifth",
    "passengers[5].firstname": "Test Sixth",
    "passengers[5].lastname": "Test Sixth",
    "passengers[6].firstname": "Test Seventh",
    "passengers[6].lastname": "Test Seventh",
    "passengers[7].firstname": "Test Eight",
    "passengers[7].lastname": "Test Eight",
    "passengers[8].firstname": "Test Ninth",
    "passengers[8].lastname": "Test Ninth",
    "passengers[].nationality": "gb",
    "passengers[].birthDay": "1",
    "passengers[].birthMonth": "1",
    "passengers[].birthYear": adultYear,
    "passengers[1].birthDay": "1",
    "passengers[1].birthYear": childYear,
    "passengers[2].birthDay": "1",
    "passengers[2].birthYear": infantYear,
    "passengers[].idNumber": "12345678XY",
    "passengers[].idExpirationDay": "24",
    "passengers[].idExpirationMonth": "12",
    "passengers[].idExpirationYear": "2020",
    "passengers[].insurance": "none",
    "passengers[].baggage.handBag": 0,
    "passengers[].baggage.holdBag": 0,
    "contact.email": user.email,
    "contact.phone": "000",
    "payment.cardNumber": "4138 4900 0000 0000",
    // "payment.cardNumber": "4111 1111 1111 1111",
    "payment.cardExpirationMonth": "1",
    "payment.cardExpirationYear": "20",
    "payment.cardCvv": "123",
    "payment.cardName": "TEST TEST",

    "paymentSpecialInfo.firstname": "APPROVED",
    "paymentSpecialInfo.lastname": "APPROVED",
    "paymentSpecialInfo.address": "85 Albert Embankment",
    "paymentSpecialInfo.city": "London",
    "paymentSpecialInfo.zipCode": "10200",
    "paymentSpecialInfo.idNumber": "12345678XY",

    "billingDetails.address": "85 Albert Embankment",
    "billingDetails.city": "London",
    "billingDetails.postalCode": "10200",
    "billingDetails.country": "gb",
    "billingDetails.companyName": "MI6",
    "billingDetails.companyId": "10006",
    "billingDetails.companyVat": "UK 753215448",
    "billingDetails.personName": "James Bond",

    "card.number": "4138 4900 0000 0000",
    // "card.number": "4111 1111 1111 1111",
    "card.expiry.month": "1",
    "card.expiry.year": "20",
    "card.securityCode": "123",
    "card.holderName": "TEST TEST",
    termsAndConditions: 1,
  }

  const filterFields = R.compose(
    R.filter(Boolean),
    R.pluck("name"),
    R.filter(Boolean),
  )

  // Prevent duplicities using Set
  const visibleFieldsSet = new Set(filterFields(document.querySelectorAll("input, select")))
  const availableFieldsSet = new Set(Object.keys(FIELDS))

  const paymentBookingVariant = state.splitster.get("BOOKING_PAYMENT").value
  if (paymentBookingVariant === "iframe") {
    // set to dev, because autofill dosn't work for production
    window.reduxStore.dispatch(set("BOOKING_PAYMENT", "iframe-dev", false))
  }

  const useIframe = paymentBookingVariant.startsWith("iframe")
  if (option !== OPTIONS.LOGIN_PASSWORD && useIframe) {
    const cardData = {
      cardNumber: FIELDS["card.number"],
      cardExpirationMonth: FIELDS["card.expiry.month"],
      cardExpirationYear: FIELDS["card.expiry.year"],
      cardCvv: FIELDS["card.securityCode"],
      cardName: FIELDS["card.holderName"],
    }
    Object.keys(cardData).forEach(key => postMessageToPayment(`autofill.${key}:${cardData[key]}`))
    Object.keys(FIELDS)
      .filter(key => key.startsWith("paymentSpecialInfo"))
      .forEach(key => postMessageToPayment(`autofill.${key}:${get([key], FIELDS)}`))
    postMessageToPayment(`checkValidity`)
  }

  const updateReservationPassengerField = key => {
    const val = get([key], FIELDS)
    window.reduxStore.dispatch({
      type: "redux-form/CHANGE",
      field: key,
      value: val,
      touch: true,
      form: "reservation",
    })
    window.reduxStore.dispatch({
      type: "redux-form/BLUR",
      field: key,
    })
  }

  switch (option) {
    case OPTIONS.RESERVATION:
      // Set the global values first
      visibleFieldsSet
        .map(R.replace(/[0-9]/g, ""))
        .intersect(availableFieldsSet)
        .forEach(updateReservationPassengerField)
      // Update fields if custom value is set
      visibleFieldsSet.intersect(availableFieldsSet).forEach(updateReservationPassengerField)
      // Accept agreements
      window.reduxStore.dispatch({
        type: "redux-form/CHANGE",
        field: "agreements.terms",
        value: true,
        touch: true,
        form: "reservation",
      })
      break

    case OPTIONS.LOGIN_PASSWORD:
      fillForm({
        ".LoginSignupModal [name=email]": user.email,
        ".LoginSignupModal [name=password]": user.password,
      })
      break
    case OPTIONS.BOOKING_PAYMENT:
      visibleFieldsSet.intersect(availableFieldsSet).forEach(key => {
        const val = get([key], FIELDS)
        window.reduxStore.dispatch({
          type: "redux-form/CHANGE",
          field: key,
          value: val,
          touch: true,
          form: "BookingPayment",
        })
        window.reduxStore.dispatch({
          type: "redux-form/BLUR",
          field: key,
        })
      })
      break
  }

  setTimeout(() => {
    cuckoo.enable()
  }, 2000) // Give browser some time
}
